"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colissimoSignatureCountries = exports.colissimoCountries = void 0;
exports.getPackageDeliveryFees = getPackageDeliveryFees;
exports.getWeight = getWeight;
exports.mondialRelayCountries = void 0;
var _orderPriceUtils = require("./orderPriceUtils");
var _transportersEUData = require("./transportersEUData");
var _sendcloudData = require("./sendcloudData");
var weightByPiece = {
  pant: 595,
  jupe: 295,
  haut: 295,
  robe: 395,
  pull: 395,
  mant: 995,
  mail: 195,
  ling: 195,
  comb: 795,
  ride: 1700,
  deco: 1700,
  cous: 300,
  mais: 700,
  belt: 395,
  wallet: 495,
  littleBag: 345,
  middleBag: 695,
  bigBag: 945,
  flat_shoes: 595,
  heeled_shoes: 595,
  boots: 895,
  heeled_boots: 1095,
  sneakers: 595,
  acce: 445
};
var minWeightG = 100;
var liningExtraWeight = 1.5;
/** @param { import("../entities/types").Order } order */
function getWeight(order) {
  var weight = order.clothes.reduce(function (sum, cloth) {
    var _weightByPiece$cloth$;
    if (cloth.process === 'AT_HOME') return sum;
    var clothWeight = 0;
    if (cloth.sizeBag) {
      clothWeight = weightByPiece[cloth.sizeBag];
    } else if (cloth.shoesType) {
      clothWeight = weightByPiece[cloth.shoesType];
    } else clothWeight = (_weightByPiece$cloth$ = weightByPiece[cloth.slug]) !== null && _weightByPiece$cloth$ !== void 0 ? _weightByPiece$cloth$ : 0;
    if (cloth.liningsNumber > 0) clothWeight *= liningExtraWeight;
    return sum + clothWeight;
  }, 0);
  return Math.max(weight, minWeightG);
}
function getSignatureExtraAmount(country) {
  switch (country) {
    case 'FR':
      return 1.2;
    case 'BE':
      return 0.6;
    case 'CH':
      return 0.5;
    default:
      return 0;
  }
}
var weightLimit = 30000;
var sendcloudExtraLabelFee = 0.1;
function convertGToKg(weight) {
  return parseFloat(weight / 1000);
}

/** @param { import("../entities/types").Order } order */
function getPackageDeliveryFees(order) {
  var _order$country;
  var transporter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var weight = getWeight(order);
  var country = (_order$country = order.country) !== null && _order$country !== void 0 ? _order$country : 'FR';
  if (!order.transporterChosenByCustomer) return 0;
  var mondialRelayPricing = country === 'FR' ? _sendcloudData.mondialRelayShippingMethods : _transportersEUData.priceMondialRelayEUByWeights;
  var colissimoPricing = country === 'FR' ? _sendcloudData.colissimoShippingMethods : _transportersEUData.priceColissimoEUByWeights;
  var priceByWeights = order.transporterChosenByCustomer === 'MONDIAL_RELAY' ? mondialRelayPricing : colissimoPricing;
  var countryOrOther = priceByWeights.length > 0 && priceByWeights[0][country] ? country : 'OTHER';
  var price = 0;
  if (weight > weightLimit) {
    price = priceByWeights[priceByWeights.length - 1][countryOrOther];
  } else {
    price = priceByWeights.find(function (priceByWeight) {
      var weightKg = convertGToKg(weight);
      return weightKg >= priceByWeight.minWeight && weightKg <= priceByWeight.maxWeight;
    })[countryOrOther];
  }
  if (order.transporterChosenByCustomer === 'COLISSIMO_SIGNATURE') {
    price += getSignatureExtraAmount(order.country);
  }
  if ((transporter === 'COLISSIMO_SIGNATURE' || transporter === undefined) && order.transporterChosenByCustomer === 'COLISSIMO_SIGNATURE') {
    if (order.transporterInsurance) {
      price += order.transporterInsurance.amount;
    }
  }
  if ((transporter === 'MONDIAL_RELAY' || transporter === undefined) && order.transporterChosenByCustomer === 'MONDIAL_RELAY') {
    if (order.transporterInsurance) {
      price += order.transporterInsurance.amount;
    }
  }
  var numberOfTripsPerOrder = 2;
  if (country === 'FR') {
    price += sendcloudExtraLabelFee;
  }
  return (0, _orderPriceUtils.round)(price * numberOfTripsPerOrder);
}
var mondialRelayCountries = exports.mondialRelayCountries = ['FR', 'BE', 'LU', 'NL', 'ES', 'PT'];
var colissimoCountries = exports.colissimoCountries = ['FR', 'BE', 'CH'];
// export const mondialRelayAtHomeCountries = ['DE', 'AT', 'IT'];
var colissimoSignatureCountries = exports.colissimoSignatureCountries = ['BE', 'CH', 'DE', 'LU', 'NL', 'UK', 'IT', 'ES', 'AT', 'PT', 'IE',
// OTHER = zone 3: Danemark, Estonie, Groenland, Hongrie, Îles Féroé, Lettonie, Liechtenstein, Lituanie, Pologne, République tchèque, Slovaquie, Slovénie, Suède
'DK', 'EE', 'GL', 'HU', 'FO', 'LV', 'LI', 'LT', 'PL', 'CZ', 'SK', 'SI', 'SE',
// zone 4
'BG', 'CY', 'HR', 'FI', 'GR', 'IS', 'MT', 'NO', 'RO'];